import * as React from 'react'

function BackgroundedSection({ children }: { children: React.ReactNode }) {
  return <div className="bg-amber-800 px-20 py-10 text-white my-20 ">{children}</div>
}

export default BackgroundedSection
